import React from 'react';

const TripListView = ({ trips, loading, appUser, onBack, onCreateTrip, onSelectTrip, onDeleteTrip }) => {
    return (
        <div>
            <button onClick={onBack} className="icon-button home-button" aria-label="กลับหน้าหลัก" title="กลับหน้าหลัก">
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M3 11l9-7 9 7"></path>
                    <path d="M5 10v10a1 1 0 0 0 1 1h4v-6h4v6h4a1 1 0 0 0 1-1V10"></path>
                </svg>
            </button>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                <h2 style={{ margin: 0, color: 'var(--color-primary)', fontFamily: 'var(--font-display)' }}>ทริปของฉัน</h2>
                <button onClick={onCreateTrip} style={{ padding: '8px 16px', backgroundColor: 'var(--color-primary)', backgroundImage: 'var(--color-primary-gradient)', color: 'white', border: 'none', borderRadius: '10px', fontWeight: 'bold', boxShadow: '0 8px 18px rgba(var(--color-primary-rgb), 0.3)' }}>+ สร้างทริป</button>
            </div>

            {loading ? <p style={{ color: 'var(--color-text-muted)' }}>Loading...</p> : trips.length === 0 ? <p style={{ textAlign: 'center', color: 'var(--color-text-subtle)', marginTop: '40px' }}>ยังไม่มีทริป</p> : (
                <div style={{ display: 'grid', gap: '15px' }}>
                    {trips.map(trip => (
                        <div key={trip.id} onClick={() => onSelectTrip(trip)} style={{ backgroundColor: 'var(--color-glass-strong)', padding: '20px', borderRadius: '16px', border: '1px solid var(--color-border)', cursor: 'pointer', boxShadow: '0 18px 36px rgba(30, 70, 90, 0.12)', position: 'relative', display: 'flex', flexDirection: 'column', gap: '8px' }}>
                            <h3 style={{ margin: 0, fontSize: '18px', color: 'var(--color-text)' }}>{trip.icon || '✈️'} {trip.name}</h3>
                            
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                {trip.members && trip.members.map((m, idx) => (
                                    <div key={idx} style={{ width: '28px', height: '28px', borderRadius: '50%', overflow: 'hidden', border: '2px solid rgba(255, 255, 255, 0.9)', marginLeft: idx > 0 ? '-10px' : '0', backgroundColor: 'var(--color-surface-muted)', zIndex: trip.members.length - idx }} title={m.display_name}>
                                        {m.picture_url ? (
                                            <img src={m.picture_url} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                                        ) : (
                                            <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '12px' }}>👤</div>
                                        )}
                                    </div>
                                ))}
                            </div>

                            <p style={{ margin: 0, fontSize: '12px', color: 'var(--color-text-subtle)' }}>{new Date(trip.created_at).toLocaleDateString('th-TH')}</p>

                            <div style={{ position: 'absolute', right: '16px', bottom: '14px', textAlign: 'right' }}>
                                <div style={{ fontSize: '16px', fontWeight: '700', color: 'var(--color-primary)' }}>
                                    {Number(trip.total_amount || 0).toLocaleString()} {trip.currency || 'THB'}
                                </div>
                            </div>
                            
                            {trip.created_by === appUser.id && (
                                <button 
                                    onClick={(e) => onDeleteTrip(e, trip)}
                                    style={{
                                        position: 'absolute',
                                        top: '15px',
                                        right: '15px',
                                        background: 'none',
                                        border: 'none',
                                        color: 'var(--color-text-subtle)',
                                        cursor: 'pointer',
                                        padding: '5px',
                                        zIndex: 10
                                    }}
                                    title="ลบทริป"
                                >
                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path><line x1="10" y1="11" x2="10" y2="17"></line><line x1="14" y1="11" x2="14" y2="17"></line></svg>
                                </button>
                            )}
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default TripListView;
